import React from 'react'

import styles from './styles.module.scss'

import ProductItem from './ProductItem/ProductItem'
import { useSelector } from 'react-redux'
import cn from 'classnames'

const Products = ({ products, ...rest }) => {
  const referralData = useSelector(({ billing }) => billing.referralData)

  return (
    <div className={cn(styles.grid, [referralData && styles.oneColumn])}>
      {products.map((product) => (
        <ProductItem key={product.id} data={product} {...rest} />
      ))}
    </div>
  )
}

export default Products
